export const buildCategoryName = (categoryName, type) => {
  return `${categoryName.split(' ').join('-')}_${type}`;
};

export const retrieveImageAssetCategoryName = (categoryName) => {
  return categoryName.split('_')[0].split('-').join(' ');
};
